// extracted by mini-css-extract-plugin
module.exports = {"root":"EABD2TabButton_root__2TlaY","active":"EABD2TabButton_active__3EyvS","text":"EABD2TabButton_text__2su4k"};